export enum PrescriptionStatus {
  SENT = 'SENT',
  SENT_UNVALIDATED = 'SENT_UNVALIDATED',
}
